
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { AdverseReactions } from '@/data/medications';

interface AdverseReactionsSectionProps {
  adverseReactions: AdverseReactions;
}

const AdverseReactionsSection: React.FC<AdverseReactionsSectionProps> = ({ 
  adverseReactions 
}) => {
  if (!adverseReactions) return null;
  
  return (
    <div className="p-3 bg-red-50 rounded-md border border-red-100 mt-1">
      <h5 className="text-xs font-semibold text-red-600 mb-1.5 flex items-center">
        <AlertCircle className="h-3 w-3 text-red-500 mr-1" />
        Adverse Reactions:
      </h5>
      
      <div className="space-y-2">
        <div className="flex items-center">
          <span className="font-medium text-red-600 text-xs md:text-sm w-24">Common:</span> 
          <span className="text-xs md:text-sm">{adverseReactions.common}</span>
        </div>
        <div className="flex items-center">
          <span className="font-medium text-amber-600 text-xs md:text-sm w-24">Less Common:</span> 
          <span className="text-xs md:text-sm">{adverseReactions.lessCommon}</span>
        </div>
        <div className="flex items-center">
          <span className="font-medium text-blue-600 text-xs md:text-sm w-24">Rare:</span> 
          <span className="text-xs md:text-sm">{adverseReactions.rare}</span>
        </div>
      </div>
    </div>
  );
};

export default AdverseReactionsSection;
